module.exports = __webpack_public_path__ + "static/media/banner_news_informacoes_do_edital.00c2fbd1.png";